import type { ReactNode } from "react";

/**
 * Pestañas dentro del layout de la ruta (no se muestran en el sidebar).
 */
export type MenuSubNavTabs = {
  kind: "tabs";
  basePath: string;
  tabs: { label: string; segment: string }[];
};

/**
 * Subpáginas bajo la misma sección (rutas anidadas; no se muestran en el sidebar).
 */
export type MenuSubNavSubpages = {
  kind: "subpages";
  routes: { label: string; path: string }[];
};

export type MenuItem = {
  text: string;
  icon: ReactNode;
  /** Ruta por defecto al hacer clic en el ítem del menú */
  path: string;
  /** Navegación interna; el sidebar solo muestra el ítem principal */
  subNav?: MenuSubNavTabs | MenuSubNavSubpages;
};

/** Definición única para Cupos: menú + layout de pestañas */
export const CUPOS_SUBNAV: MenuSubNavTabs = {
  kind: "tabs",
  basePath: "/cupos",
  tabs: [
    { label: "Por producto", segment: "producto" },
    { label: "Por cliente", segment: "cliente" },
  ],
};
